import { RootState } from '@/app/reducers'
import { availableToAllUsers, Feature } from '@/config/features'
import { useSelector } from 'react-redux'

/** The RevenueCat entitlement id that represents DUPR+. */
export const DUPR_PLUS_RC_ENTITLEMENT = 'dupr_tournaments_paid_level1_v1'

export function useHasDuprPlus() {
  const entitlements = useSelector((state: RootState) => state.entitlements)

  const treatAsDuprPlus =
    entitlements?.includes(DUPR_PLUS_RC_ENTITLEMENT) || entitlements?.includes('loading_entitlements')
  return treatAsDuprPlus
}

export function useHasFeature(feature: Feature, fallback?: boolean): boolean {
  return useSelector((state: RootState) => {
    const value = state.remoteConfig.values[feature]

    if (typeof value === 'boolean') return value

    if (fallback !== undefined) return fallback

    return availableToAllUsers.includes(feature)
  })
}
